/**
 * GET-AXIS-FROM-TOPIC
 * Format list of axis from list of topics
 */

import { compact, uniqBy } from "lodash"
import { Topic } from "@/redux/topic.types"
import { Axis } from "@/redux/axis.types"
import { store } from "@/core/root-reducer"
import { axisGet } from "@/redux/axis.actions"
import { ProjectAxisRule } from "@/redux/project.types"
import { Population } from "@/redux/population.types"

const getAxisFromTopic = (
  topics: Topic[],
  segmentationByAxesRules: ProjectAxisRule[],
  observerAttributes: Population[]
) => {
  let axes: Axis[] = uniqBy(compact(topics.map((x) => x.Axis)), "id")
  axes = axes.filter((x) => x.isDisplayed(segmentationByAxesRules, observerAttributes))
  store.dispatch(axisGet(axes, []))
}

export default getAxisFromTopic
